import React from 'react';

import { classnames } from '@/utils/classnames.ts';

const AppLogo = ({ className, ...props }: React.ComponentPropsWithRef<'span'>) => (
    <span
        {...props}
        className={classnames(
            'flex size-9 shrink-0 items-center justify-center text-lg font-semibold text-text',
            className
        )}
    >
        R
    </span>
);

export default AppLogo;
